import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DetailCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0m8 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4", clipRule: "evenodd" })));
}
const DetailCustom = forwardRef(_DetailCustom);
export { DetailCustom };
